import { Row, Col, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LoadingSpinner } from "../../components";
import { Formik } from "formik";

export default function AuthForm(props) {
  // login/register form 
  
  return (
    <Row className="mt-5 justify-content-md-center">
      <Col
        md={6}
        className="p-4"
        style={{ backgroundColor: "#f6f6f6", borderRadius: "20px" }}
      >
        <h1>{props.login ? "Login" : "Register"}</h1>
        <Formik
          initialValues={props.initialValues}
          validationSchema={props.validationSchema}
          onSubmit={ async (values, { setSubmitting }) => {
            await props.handleFormSubmission(values);
            setSubmitting(false);
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            errors,
            isSubmitting,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              {props.formFields.map((field, idx) => (
                <Form.Group key={idx} className="mb-3" controlId={field.name}>
                  <Form.Label>{field.label}</Form.Label>
                  <Form.Control
                    type={field.type}
                    name={field.name}
                    value={values[field.name]}
                    onChange={handleChange}
                    isInvalid={touched[field.name] && !!errors[field.name]} //errors.email
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              ))}

              {props.login && (
                <Form.Group className="mb-3" controlId="stayLoggedIn">
                  <Form.Check
                    type="checkbox"
                    name="stayLoggedIn"
                    label="Keep me signed in"
                    value={values.stayLoggedIn}
                    onChange={handleChange}
                  />
                </Form.Group>
              )}

              <Row className="pb-2">
                {props.login && (
                  <Col>
                    Don't have an account?{" "}
                    <Link to={"/register"}> Register</Link>
                  </Col>
                )}
                {props.registration && (
                  <Col>
                    Already have an account?
                    <Link to={"/login"}> Login</Link>
                  </Col>
                )}
              </Row>

              <Button type="submit">
                {isSubmitting && (
                  <LoadingSpinner button={true} variant="light" />
                )}{" "}
                {props.login?"Login":"Register"}
              </Button>
            </Form>
          )}
        </Formik>
      </Col>
    </Row>
  );
}
